export default __webpack_public_path__ + "static/media/broken.498d78be.svg";